/**
 * ODHNI BRAND CONFIGURATION — frontend source of truth.
 * Stable `--kazo-*` CSS variable names are retained for compatibility.
 */
export const BRAND = {
  name: "ODHNI",
  legalName: "Odhni",
  domain: "odhni.com",
  shortDescriptor: "women's ethnic-wear brand, established in 1999",

  logoUrl: "/odhni-logo.webp",
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Fundle Brain",
  platformLogoUrl: "/fundle-logo.png",

  loyaltyProgramName: "Odhni Rewards",
  welcomeToast: "Welcome to Odhni Rewards. Your membership is now active.",
  ctaJoinFree: "Join Odhni Rewards Free",

  categories: [
    "Sarees", "Lehengas", "Suits/Salwar", "Kurtis", "Gowns",
    "Indo-Western", "Dupattas", "Bottoms", "Accessories",
  ],

  social: {
    instagram: "https://www.instagram.com/odhniworld",
    facebook: "https://www.facebook.com/odhniworld",
    youtube: "https://www.youtube.com/@odhniworld",
  },

  meta: {
    title: "Odhni Rewards — Powered by Fundle",
    description:
      "Join Odhni Rewards and unlock loyalty privileges across Odhni's sarees, lehengas, suits, kurtis, gowns and Indo-Western collections.",
  },

  homeCopy: {
    heroEyebrow: "An Exclusive Programme · Powered by Fundle",
    heroSubtext:
      "The official Odhni loyalty programme. Celebrate every occasion with privileges shaped around your journey with us.",
    heroImageAlt: "Odhni bridal and occasion-wear collection",
    boutiqueImageAlt: "Odhni wedding trousseau collection",
    editorialImageAlt: "Odhni red bridal lehenga",
    stats: [
      { value: "Since 1999", label: "Heritage" },
      { value: "Delhi-NCR", label: "Home" },
      { value: "9", label: "Categories" },
    ],
  },

  assets: {
    hero: "/odhni-hero.png",
    editorial: "/odhni-editorial.webp",
    rewards: "/odhni-rewards.webp",
    boutique: "/odhni-boutique.png",
  },

  footerTagline:
    "The official loyalty programme for Odhni — celebrating Indian craftsmanship, memorable occasions and every relationship since 1999.",

  loginCopy: {
    descriptor:
      "A unified suite for loyalty, CRM, analytics and campaigns — purpose-built for Odhni.",
    imageAlt: "Odhni ethnic-wear collection",
  },

  colors: {
    black: "#1B1416",
    cream: "#FFF9F7",
    burgundy: "#D4145A",
    burgundyDeep: "#9F123F",
    champagne: "#D9A441",
    champagneLight: "#F3DFAE",
  },
};

export default BRAND;